"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterButton = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var AttributeFilterBase_1 = require("./AttributeFilterBase");
var AttributeFilterDropdownButton_1 = require("./Components/DropdownButton/AttributeFilterDropdownButton");
/**
 * AttributeFilterButton is a component that renders a rich button and a dropdown populated with attribute values
 * for specified attribute display form.
 * @public
 */
exports.AttributeFilterButton = function (props) {
    var _a, _b, _c;
    return (react_1.default.createElement(AttributeFilterBase_1.AttributeFilterBase, tslib_1.__assign({}, props, { DropdownButtonComponent: (_a = props.DropdownButtonComponent) !== null && _a !== void 0 ? _a : AttributeFilterDropdownButton_1.AttributeFilterDropdownButton, LoadingComponent: (_b = props.FilterLoading) !== null && _b !== void 0 ? _b : props.LoadingComponent, ErrorComponent: (_c = props.FilterError) !== null && _c !== void 0 ? _c : props.ErrorComponent })));
};
//# sourceMappingURL=AttributeFilterButton.js.map